import React, { useEffect, useState } from "react";
import { Popup } from "semantic-ui-react";
import CreateMcq from "./Create_Q_Type/CreateMcq";
import CrossAttachmentAssessment from "../Attachment/CrossAttachmentAssessment";
import CreateUploadType from "./Create_Q_Type/CreateUploadType";
import CreatePopup from "../Create_three_dot_box/CreatePopup";
// css comes in create_hw_file.css in homework
import axios from "../../../../axios";
import Guides from "../../../../Homework/pages/Create_Assessment/Create_Question/Create_Q_Type/Guides";

const DefaultQuestion = ({
  nextQuestion,
  question,
  setQuestions,
  assessmentDetails,
  qArr,
  setSkillsData,
  setDifficulty_levelData,
  setQuestionType,
}) => {
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  let school_id = JSON.parse(localStorage.getItem("schoolId"));
  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId")
  );

  const [fLimit, setFLimit] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isValidFileType, setIsValidFileType] = useState(true);
  const [addquestion, setAddQuestion] = useState("");
  const [click, setClick] = useState(false);
  const [dropdownList, setDropdownList] = useState({
    skills: null,
    types: null,
    domains: null,
    chapters: null,
    difficultyLevels: null,
  });
  const [popupOpen, setPopupOpen] = useState(false);

  const handleClosePopup = () => {
    setPopupOpen(false);
  };
  const { skills, types, domains, chapters, difficultyLevels } = dropdownList;

  useEffect(() => {
    try {
      const getDetails = async () => {
        let skills = await axios.get(`/api/v1/school/skill/get`);

        if (skills) {
          setDropdownList((prev) => ({ ...prev, skills: skills?.data?.data }));
          setSkillsData(skills?.data?.data);
        }
        let chapters = await axios.get(
          // `/api/v1/school/book/get/standardId/${assessmentDetails?.standard_id?.id}?sectionId=${assessmentDetails?.section_id?.id}&subjectId=${assessmentDetails?.subject_id?.id}&isWithChapters=true`
          `/api/v1/cm/library/book/getBookByClassSectionSubject?standard_id=${assessmentDetails?.standard_id?.id}&section_id=${assessmentDetails?.section_id?.id}&subject_id=${assessmentDetails?.subject_id?.id}&timetableSessionId=${timeTableSessionId}`
        );
        chapters &&
          setDropdownList((prev) => ({
            ...prev,
            chapters: chapters.data.data,
          }));

        let domains = await axios.get(`/api/v1/school/domain/get`);
        domains &&
          setDropdownList((prev) => ({ ...prev, domains: domains.data.data }));

        let types = await axios.get(
          `/api/v1/questionType/get/school/${school_id}`
        );
        if (types) {
          setDropdownList((prev) => ({ ...prev, types: types.data.data }));
          setQuestionType(types.data.data);
        }

        let difficultyLevels = await axios.get(`/api/v1/difficultyLevel/get`);

        if (difficultyLevels) {
          setDropdownList((prev) => ({
            ...prev,
            difficultyLevels: difficultyLevels.data.data,
          }));
          setDifficulty_levelData(difficultyLevels.data.data);
        }
      };
      getDetails();
    } catch (error) {
      console.log(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validateFileType = (filePath) => {
    var allowedExtensions =
      /(\.jpg|\.jpeg|\.png|\.pdf|\.mp3|\.mp4|\.pptx|\.ppt)$/i;

    if (
      !allowedExtensions.exec(filePath.name) ||
      question?.attachments?.length > 5
    ) {
      setIsValidFileType(false);
      return false;
    }
    setIsValidFileType(true);
    return true;
  };

  const handleAttachment = async (files) => {
    let attachments = [];
    let attachments_sizeKb = [];
    const maxSize = 10 * 1024 * 1024; // 25MB in bytes
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file.size > maxSize) {
        setFLimit(true);
        return;
      }
    }
    if (files) {
      for (const file of files) {
        if (validateFileType(file)) {
          try {
            setLoader(true);
            let formData = new FormData();
            formData.append("name", file.name);
            formData.append("uploadQuestionAttachment", file);
            let res = await axios.post(
              `/api/v1/question/uploadAttachment/teacherId/${teacher_id}`,
              formData
            );

            attachments_sizeKb.push(Math.round(file.size / 1024));
            res && attachments.push(res.data.data);
            res && setFLimit(false);
            setLoader(false);
          } catch (error) {
            console.log(error);
            setLoader(false);
          }
        }
      }
      if (attachments.length > 0) {
        setQuestions((prev) => {
          const updatedQuestion = {
            ...prev[nextQuestion],
            attachments: attachments,
            attachments_sizeKb,
          };
          const newQuestion = [...prev];
          newQuestion[nextQuestion] = updatedQuestion;
          return newQuestion;
        });
      }
    }
  };
  return (
    <>
      <div className="d-flex align-items-center justify-content-center ">
        <div className="col-11 m-0 mt-2 p-3 question_box_container  ">
          <div className=" d-flex">
            <div className="hw_question_no me-2">Q{nextQuestion + 1}</div>

            <input
              onChange={(e) => {
                const value = e.target.value;
                // I allow some special character for question input field
                setAddQuestion(value);
                setQuestions((prev) => {
                  const updatedQuestion = {
                    ...prev[nextQuestion],
                    title: value,
                  };
                  const newQuestion = [...prev];
                  newQuestion[nextQuestion] = updatedQuestion;
                  return newQuestion;
                });
              }}
              maxLength={100}
              className="hw_question_box "
              placeholder="Add question"
              // Because of "question.title" I am able to write special character prevent this issue I added state
              value={question.title ? question.title : addquestion}
            />
            {qArr && qArr.length > 1 && (
              <Popup
                on="click"
                open={popupOpen}
                onClose={handleClosePopup}
                trigger={
                  <div
                    className="hw_three_dots"
                    onClick={() => setPopupOpen((prev) => !prev)}
                  >
                    <img src="/images/upload.svg" alt="" />
                  </div>
                }
                content={
                  <div className="hw_popup_box_size" onClick={handleClosePopup}>
                    <CreatePopup
                      questionIndex={nextQuestion}
                      setQuestions={setQuestions}
                    />
                  </div>
                }
              />
            )}
          </div>
          <div className=" mt-2 d-flex align-items-center hw_default_dropdown_container ">
            <div className=" hw_default_dropdown_size">
              <span className="hw_default_dropdown_box_header">
                KNOWLEDGE DOMAIN
              </span>
              <select
                onChange={(e) =>
                  setQuestions((prev) => {
                    const updatedQuestion = {
                      ...prev[nextQuestion],
                      domain_id: e.target.value,
                    };
                    const newQuestion = [...prev];
                    newQuestion[nextQuestion] = updatedQuestion;
                    return newQuestion;
                  })
                }
                value={question.domain_id}
                label={domains?.some((d) => d.id === question.domain_id).name}
                className="form-select hw_default_sub_dropdown_size"
              >
                <option selected>Select Knowledge Domain</option>
                {domains &&
                  domains.map((domain, index) => (
                    <option key={index} value={domain.id}>
                      {domain.name}
                    </option>
                  ))}
              </select>
            </div>
            <div className="hw_default_dropdown_size">
              <span className="hw_default_dropdown_box_header">SKILLS</span>

              <select
                onChange={(e) =>
                  setQuestions((prev) => {
                    const updatedQuestion = {
                      ...prev[nextQuestion],
                      skill_id: e.target.value,
                    };
                    const newQuestion = [...prev];
                    newQuestion[nextQuestion] = updatedQuestion;
                    return newQuestion;
                  })
                }
                value={question.skill_id}
                label={skills?.some((s) => s.id === question.skill_id).name}
                className="form-select hw_default_sub_dropdown_size"
              >
                <option value="" placeholder="dd">
                  Select Skill
                </option>
                {skills &&
                  skills?.map((skill, index) => (
                    <option key={index} value={skill.id} placeholder="dd">
                      {skill.name}
                    </option>
                  ))}
              </select>
              <span
                onClick={() => setClick(true)}
                style={{
                  position: "absolute",
                  left: "37%",
                  fontSize: "12px",
                  color: "red",
                  cursor: "pointer",
                }}
              >
                Click here to more details
              </span>
            </div>
            <div className="hw_default_dropdown_size">
              <span className="hw_default_dropdown_box_header">
                TYPE OF QUESTION
              </span>

              <select
                onChange={(e) =>
                  setQuestions((prev) => {
                    let updatedQuestion;
                    if (
                      e.target.options[e.target.selectedIndex].getAttribute(
                        "data-is-manually-graded"
                      ) === "true"
                    ) {
                      updatedQuestion = {
                        ...prev[nextQuestion],
                        type_id: e.target.value,
                        question_type: String(
                          e.target.options[e.target.selectedIndex].getAttribute(
                            "data-is-manually-graded"
                          )
                        ),
                        options: [],
                        correct_answers: [
                          {
                            reason_for_answer: {
                              explanation: null,
                              attachments: null,
                            },
                          },
                        ],
                      };
                    } else {
                      updatedQuestion = {
                        ...prev[nextQuestion],
                        type_id: e.target.value,
                        question_type: String(
                          e.target.options[e.target.selectedIndex].getAttribute(
                            "data-is-manually-graded"
                          )
                        ),
                        options: [
                          {
                            key: String.fromCharCode(0 + 65),
                            value: null,
                          },
                          {
                            key: String.fromCharCode(1 + 65),
                            value: null,
                          },
                        ],
                      };
                    }

                    const newQuestion = [...prev];
                    newQuestion[nextQuestion] = updatedQuestion;
                    return newQuestion;
                  })
                }
                value={question.type_id}
                label={types?.some((t) => t.id === question.type_id).name}
                className="form-select hw_default_sub_dropdown_size"
              >
                <option value="null">Select QuestionType</option>
                {types &&
                  types?.map((type, index) => (
                    <option
                      key={index}
                      value={type.id}
                      data-is-manually-graded={type?.is_manually_graded}
                    >
                      {type.name}
                    </option>
                  ))}
              </select>
            </div>

            <div className="hw_default_dropdown_size ">
              <span className="hw_default_dropdown_box_header">CHAPTER</span>

              <select
                id="bookChapterSelect"
                className="hw_default_sub_dropdown_size form-select"
                onChange={(e) =>
                  setQuestions((prev) => {
                    const updatedQuestion = {
                      ...prev[nextQuestion],
                      chapter_id: e.target.value,
                      book_id:
                        e.target.options[e.target.selectedIndex].getAttribute(
                          "book-id"
                        ),
                    };
                    const newQuestion = [...prev];
                    newQuestion[nextQuestion] = updatedQuestion;
                    return newQuestion;
                  })
                }
                value={question.chapter_id}
              >
                <option value="null">Select Chapter</option>
                {chapters?.length > 0 &&
                  chapters?.map((item) =>
                    item.bookInfo.map((book) => (
                      <optgroup
                        label={book.name} // Display book name as the group label
                        key={book.id}
                        book-id={book.id}
                      >
                        {book.chapterData
                          .slice()
                          .sort((a, b) => {
                            const chapterNumA = parseInt(
                              a.chapterName.match(/\d+/)[0]
                            );
                            const chapterNumB = parseInt(
                              b.chapterName.match(/\d+/)[0]
                            );
                            return chapterNumA - chapterNumB;
                          })
                          .map((chapter) => (
                            <option
                              key={chapter.id}
                              book-id={book.id}
                              book-name={book.name}
                              value={chapter.id}
                            >
                              {chapter.chapterName}
                            </option>
                          ))}
                      </optgroup>
                    ))
                  )}
              </select>

              {/* <select
                onChange={(e) =>
                  setQuestions((prev) => {
                    const updatedQuestion = {
                      ...prev[nextQuestion],
                      chapter_id: e.target.value,
                    };
                    const newQuestion = [...prev];
                    newQuestion[nextQuestion] = updatedQuestion;
                    return newQuestion;
                  })
                }
                value={question.chapter_id}
                label={chapters?.some((c) => c.id === question.chapter_id).name}
                className="form-select hw_default_sub_dropdown_size"
              >
                <option>Select Chapter</option>
                {chapters &&
                  chapters.map((chapter, index) => (
                    <option key={index} value={chapter.id}>
                      {chapter.name}
                    </option>
                  ))}
              </select> */}
            </div>
          </div>

          <div className="mt-2 hw_default_dropdown_container  d-flex align-ites-center justify-content-between">
            <div className=" d-flex align-items-center gap-5">
              <div className="hw_mandatory_checkbox ">
                <input
                  onChange={() =>
                    setQuestions((prev) => {
                      const updatedQuestion = {
                        ...prev[nextQuestion],
                        is_mandatory: !question.is_mandatory,
                      };
                      const newQuestion = [...prev];
                      newQuestion[nextQuestion] = updatedQuestion;
                      return newQuestion;
                    })
                  }
                  type="checkbox"
                  checked={question.is_mandatory}
                />
                &nbsp;
                <span>Mandatory question</span>
              </div>
              <div className="hw_mandatory_checkbox ">
                <input
                  onChange={() =>
                    setQuestions((prev) => {
                      const updatedQuestion = {
                        ...prev[nextQuestion],
                        add_to:
                          prev[nextQuestion].add_to !== "homework"
                            ? "homework"
                            : null,
                      };
                      const newQuestion = [...prev];
                      newQuestion[nextQuestion] = updatedQuestion;
                      return newQuestion;
                    })
                  }
                  type="checkbox"
                  checked={question.add_to === "homework"}
                />
                &nbsp;
                <span>Add for Homework</span>
              </div>
            </div>
            <div className="p-0 time_duration_box d-flex justify-content-between ">
              <div
                style={{
                  width: "calc(50% - 2px)",
                  transform: "translateX(10px)",
                }}
              >
                <span className="hw_default_dropdown_box_header">MARKS</span>
                <input
                  onChange={(e) => {
                    const inputValue = parseInt(e.target.value, 10);
                    //Here I set the marks range min (0) and max (200)
                    if (inputValue >= 0 && inputValue <= 200) {
                      setQuestions((prev) => {
                        const updatedQuestion = {
                          ...prev[nextQuestion],
                          correct_score: inputValue,
                        };
                        const newQuestion = [...prev];
                        newQuestion[nextQuestion] = updatedQuestion;
                        return newQuestion;
                      });
                    } else if (inputValue > 200) {
                      setQuestions((prev) => {
                        const updatedQuestion = {
                          ...prev[nextQuestion],
                          correct_score: 200,
                        };
                        const newQuestion = [...prev];
                        newQuestion[nextQuestion] = updatedQuestion;
                        return newQuestion;
                      });
                      //I added this logic inputValue should not be in minus (-1)
                    } else if (inputValue < 0) {
                      setQuestions((prev) => {
                        const updatedQuestion = {
                          ...prev[nextQuestion],
                          correct_score: 0,
                        };
                        const newQuestion = [...prev];
                        newQuestion[nextQuestion] = updatedQuestion;
                        return newQuestion;
                      });
                    } else {
                      setQuestions((prev) => {
                        const updatedQuestion = {
                          ...prev[nextQuestion],
                          correct_score: null,
                        };
                        const newQuestion = [...prev];
                        newQuestion[nextQuestion] = updatedQuestion;
                        return newQuestion;
                      });
                    }
                  }}
                  id="marks"
                  type="number"
                  className="form-control hw_default_sub_dropdown_size"
                  placeholder="Enter Marks"
                  value={question.correct_score}
                  min="0"
                  max="200"
                />
                {/* I removed state which is use validate marks should be > 0 and add new logic "question.correct_score === null ||" */}
                <span style={{ color: "red", fontSize: "10px" }}>
                  {question.correct_score === null || ""
                    ? "Marks should be > 0"
                    : ""}
                </span>
              </div>
              <div style={{ width: "50%" }}>
                <span className="hw_default_dropdown_box_header">
                  LEVEL OF DIFFICULTY
                </span>
                <select
                  onChange={(e) =>
                    setQuestions((prev) => {
                      const updatedQuestion = {
                        ...prev[nextQuestion],
                        difficulty_level: e.target.value,
                      };
                      const newQuestion = [...prev];
                      newQuestion[nextQuestion] = updatedQuestion;
                      return newQuestion;
                    })
                  }
                  value={question.difficulty_level}
                  label={
                    difficultyLevels?.some(
                      (d) => d.id === question.difficulty_level
                    ).name
                  }
                  className="form-select hw_default_sub_dropdown_size"
                >
                  <option>Select Difficulty</option>
                  {difficultyLevels &&
                    difficultyLevels.map((difficultyLevel, index) => (
                      <option key={index} value={difficultyLevel.id}>
                        {difficultyLevel.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          </div>
          {/* {question.question_type && question.question_type === "true" && ( */}
          <div className=" mt-2 hw_default_dropdown_container d-flex ">
            <input
              onChange={(e) => {
                handleAttachment(e.target.files);
              }}
              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
              multiple
              type="file"
              id={`attachFile${nextQuestion}`}
              style={{ display: "none" }}
            />
            <label className="pt-1" htmlFor={`attachFile${nextQuestion}`}>
              <img src="images/Attach.svg" alt="" />
              <span className="hw_mandatory_checkbox">&nbsp;Attach</span>
            </label>
            {loader && (
              <img
                style={{ width: "32px", height: "32px" }}
                src="/gif/Loader.gif"
              />
            )}
            <span style={{ color: "red" }}>
              {fLimit && "file size should not exceed more than 10 MB"}
            </span>
            {question.attachments.length > 0 &&
              question.attachments.map((attachment, idx) => (
                <CrossAttachmentAssessment
                  key={idx}
                  attachment={attachment}
                  isEditable={true}
                  setQuestions={setQuestions}
                  nextQuestion={nextQuestion}
                />
              ))}
          </div>
          {!isValidFileType && (
            <p id="errorMsg">
              Please upload a file with a valid extension (pdf, jpg, jpeg, png,
              pptx, ppt, mp3, mp4), Max Limit = 5.
            </p>
          )}
          {/* )} */}

          {question.question_type !== "" &&
            question.question_type === "false" ? (
            <CreateMcq
              nextQuestion={nextQuestion}
              question={question}
              setQuestions={setQuestions}
            />
          ) : (
            question.question_type !== "null" && (
              <CreateUploadType
                nextQuestion={nextQuestion}
                question={question}
                setQuestions={setQuestions}
              />
            )
          )}
          {click && <Guides setClick={setClick} />}
        </div>
      </div>
    </>
  );
};

export default DefaultQuestion;
